export function formatDateToYYYYMMDD(dateString) {
  const date = new Date(dateString)
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const dd = String(date.getDate()).padStart(2, "0")
  return `${yyyy}-${mm}-${dd}`
}

export function formatDate(dateStr) {
  if (!dateStr) return ""
  const date = new Date(dateStr)

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric"
  })
}

export function formatTime(input) {
  if (!input) return ""

  let date

  if (typeof input === "string" && input.includes("T")) {
    // It's a full date string
    date = new Date(input)
  } else if (typeof input === "string" && input.includes(":")) {
    // It's a time string like "14:30"
    const [hour, minute] = input.split(":")
    date = new Date()
    date.setHours(Number(hour), Number(minute), 0, 0)
  } else if (input instanceof Date) {
    // It's a Date object
    date = input
  } else {
    return ""
  }

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  })
}
